export const MAX_POD_PHOTOS_PER_STOP = 10;
export const MIN_POD_PHOTOS_REQUIRED = 4;
